import { Outlet } from 'react-router'

const PPCComparisionsLayout = () => {
  return (
    <Outlet />
  )
}

export default PPCComparisionsLayout